"use strict";

// QueryStringHelper
module.exports = {
	simpleQueryAsObject: function (windowOverride) {
		windowOverride = windowOverride || window;
		var query = windowOverride.location.search;
		if (query) {
			query = query.substring(1);
		}
		var obj = {};
		query.replace(/([^=&]+)=([^&]*)/g, (match, key, value) => {
			obj[decodeURIComponent(key)] = decodeURIComponent(value);
		});
		return obj;
	},

	objectFromQueryString: function (queryString) {
		queryString = queryString || "";

		var obj = {};
		queryString.replace(/([^=&]+)=([^&]*)/g, (match, key, value) => {
			obj[decodeURIComponent(key)] = decodeURIComponent(value);
		});
		return obj;
	},

	//Here are some test cases to test the createQueryString and createObjectFromQueryString
	//All of these examples work fine when calling createQueryString({...}) to convert it to a query string
	//You can then take the results of that and pass the string into createObjectFromQueryString("...") and it will convert it back into an object
	//	{components: ["test", "one"]}
	//	{search: "book", category: 20, components: [{ id: "o99084", offset: 6, limit: 6, tangibleTypes: "PROJECT,PRODUCTS", sort: "title", ascending: true} ]}
	//	{search: "book", category: 20, components: [{ id: "o99084", offset: 6, limit: 6, tangibleTypes: "PROJECT,PRODUCTS", sort: "title", ascending: true, secondary: { id2: "1234"}} ]}
	//	{search: "book", category: 20, components: [{ id: "o99084", offset: 6, limit: 6, tangibleTypes: "PROJECT,PRODUCTS", sort: "title", ascending: true, secondary: { id2: "1234", third: { id3: "5678"}}} ]}
	//	{search: "book", category: 20, components: [{ id: "o99084", offset: 6, limit: 6, tangibleTypes: "PROJECT,PRODUCTS", sort: "title", ascending: true, secondary: { id2: "1234", third: { id3: "5678"}, id2a: "123"}} ]}
	//	{search: "book", category: 20, components: [{ id: "o99084", offset: 6, limit: 6, nestedArray1: [{nest1: "a", nest2: "b"}], tangibleTypes: "PROJECT,PRODUCTS", sort: "title", ascending: true} ]}
	//	{search: "book", category: 20, components: [{ id: "o99084", offset: 6, limit: 6, nestedArray1: [{nest1: "a", nest2: "b"}, {nest1:"y", nest2: "z"}], tangibleTypes: "PROJECT,PRODUCTS", sort: "title", ascending: true} ]}
	//	{search: "book", category: 20, components: [{ id: "o99084", offset: 6, limit: 6, nestedArray1: [{nest1: "a", nest2: "b"}, {nest1:"y", nest2: "z"}], tangibleTypes: "PROJECT,PRODUCTS", sort: "title", ascending: true} }
	//	{search: "book", category: 20, components: [{ id: "o99084", offset: 6, limit: 6, nestedArray1: [{nest1: "a", nest2: "b"}, {nest1:"y", nest2: "z"}], tangibleTypes: "PROJECT,PRODUCTS", sort: "title", ascending: true}, {id: "1", offset: 2, limit: 3, nestedArray: [{nest1: "x"}], tangibleTypes: 4, sort: 5, ascending: false} ]}
	//	{search: "book", category: 20, components: [{ id: "o99084", offset: 6, limit: 6, nestedArray1: [{nest1: "a", nest2: "b"}, {nest1:"y", nest2: "z"}], tangibleTypes: "PROJECT,PRODUCTS", sort: "title", ascending: true}, {id: "1", offset: 2, limit: 3, nestedArray: [], tangibleTypes: 4, sort: 5, ascending: false} ]}
	createQueryString: function (obj, prefix) {
		var queryStringArray = [];
		var property;
		var isArray = Array.isArray(obj);
		for (property in obj) {
			if (obj.hasOwnProperty(property)) {
				var key;
				if (isArray) {
					key = prefix ? `${prefix}[${property}]` : property;
				} else {
					//C# uses the . instead of [] notation
					key = prefix ? `${prefix}.${property}` : property;
				}
				var value = obj[property];

				if (value !== null) {
					queryStringArray.push(typeof value === "object" ? this.createQueryString(value, key) : `${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
				}
			}
		}
		return queryStringArray.join("&");
	},

	createObjectFromQueryString: function(queryString) {
		//If this is falsy or not a string, just return an empty object.
		if (!queryString || typeof queryString !== "string") {
			return {};
		}

		var finalResult = {};
		//Split query by ampersand
		var keyValuePairs = queryString.split("&");
		keyValuePairs.forEach((keyValuePair) => {
			//Go through each pair, split on equal
			var values = keyValuePair.split("=");
			//If we do not have exactly two pieces, ignore
			if (values.length === 2) {
				var key = decodeURIComponent(values[0]);
				var value = decodeURIComponent(values[1]);

				//Check to see if we have an array or object notation
				var indexPeriod = key.indexOf(".");
				var indexBracket = key.indexOf("[");

				if (indexPeriod >= 0 && (indexBracket === -1 || indexPeriod < indexBracket)) {
					//The first notation is an object
					var endingKey = key.substring(indexPeriod);
					key = key.substring(0, indexPeriod);

					//If the object does not exist create it
					if (!finalResult[key]) {
						finalResult[key] = {};
					}
					//Handle the object
					this._createNestedObjectFromQueryStringPieces(endingKey, value, finalResult[key]);
				} else if (indexBracket >= 0) {
					//We have an array, handle it
					this._createArrayFromQueryStringPieces(key, value, finalResult);
				} else {
					//Just a simple key/value pair
					finalResult[key] = value;
				}
			}
		});

		return finalResult;
	},

	_createArrayFromQueryStringPieces: function(key, value, currentResult, endingKey) {
		//We are dealing with an array, find the starting and ending bracket to get the index
		var indexOpen = key.indexOf("[");
		var indexEnd = key.indexOf("]");
		var index = key.substring(indexOpen + 1, indexEnd);

		//Now get the array Name
		var arrayName = key.substring(0, indexOpen);
		//endingKey is anything after the closing bracket
		endingKey = key.substring(indexEnd + 1);

		if (!currentResult[arrayName]) {
			//If this is the first time we've seen this array, create it
			currentResult[arrayName] = [];
		}

		//Do we have object notation next
		var startWithPeriod = endingKey.startsWith(".");

		if (startWithPeriod) {
			//We have object notation next
			var arrayObject = {};
			var alreadyExists = false;
			if (currentResult[arrayName][index]) {
				//If an object already exists here
				arrayObject = currentResult[arrayName][index];
				alreadyExists = true;
			}

			//Handle the object
			this._createNestedObjectFromQueryStringPieces(endingKey, value, arrayObject);
			if (!alreadyExists) {
				//If we didn't already have the object, add it to the array at the current index
				currentResult[arrayName][index] = arrayObject;
			}
		} else {
			//No object notation, just a primitive value in the array
			//Get whatever is at this array's current index
			var currentArrayObject = currentResult[arrayName][index];
			if (!currentArrayObject) {
				//If there is no item, just add the value here
				currentResult[arrayName].splice(index, 0, value);
			} else {
				//If there is an item, it should be an object if we get here, just add this value to the object (the value should be an object too)
				Object.assign(currentResult[arrayName][index], value);
			}
		}
	},

	_createNestedObjectFromQueryStringPieces: function(key, value, currentObject) {
		//We are dealing with an object
		var indexPeriod = key.indexOf(".");

		//Getting the possible object key
		key = key.substring(indexPeriod + 1);

		//If we do not have an array or object notation next, just add the value to the object
		if (!key.includes("[") && !key.includes(".")) {
			currentObject[key] = value;
			return;
		}

		indexPeriod = key.indexOf(".");
		var indexBracket = key.indexOf("[");

		if (indexPeriod >= 0 && (indexBracket === -1 || indexPeriod < indexBracket)) {
			//We have object noation next
			//Get the value from the first period and onward
			var endingKeyFromPeriod = key.substring(indexPeriod);

			//Get the actual object key
			key = key.substring(0, indexPeriod);

			//If this object does not exist, create it.
			if (!currentObject[key]) {
				currentObject[key] = {};
			}

			//Handle the object
			this._createNestedObjectFromQueryStringPieces(endingKeyFromPeriod, value, currentObject[key]);
		} else if (indexBracket >= 0) {
			//We have an array, handle it
			this._createArrayFromQueryStringPieces(key, value, currentObject);
		}
	}
};
